import { CalendarDays, ArrowLeftRight, Snowflake } from "lucide-react";
import { montarBonus, type BonusMd, type BonusScreen } from "@/lib/bonusesMd";
import firstTwoWeeksMd from "./content/first-two-weeks.md?raw";
import plateSwapChartMd from "./content/plate-swap-chart.md?raw";
import sundayInTwoHoursMd from "./content/sunday-in-two-hours.md?raw";

/**
 * Os três bônus que a oferta do Clean Meals promete, entregues junto com o
 * produto. Como os outros bônus do app, não são produto da Hotmart: não têm id
 * e não têm gate próprio — ter o 7381661 é o que destrava.
 *
 * O corte em telas (abertura preservada; sem `##`, o corpo inteiro vira uma
 * tela — o Plate Swap Chart é uma tabela só) mora em src/lib/bonusesMd.ts.
 * Era cópia do Clean Cakes com uma dívida declarada: "quando um terceiro
 * módulo precisar de bônus, extrair". O terceiro foi o Clean Bakes (25/09/2026)
 * e a extração foi feita; os três produtos apontam para o mesmo maquinário.
 *
 * A prosa mora em .md ao lado deste arquivo em vez de string no código, para
 * continuar editável como texto.
 */
export type { BonusScreen };
export type CleanMealsBonus = BonusMd;

export const CLEAN_MEALS_PREFIX = "/clean-meals";

export const CLEAN_MEALS_BONUSES: CleanMealsBonus[] = [
  montarBonus(
    "first-two-weeks",
    "The First Two Weeks",
    "Fourteen dinners, already decided, with the grocery list for each week",
    CalendarDays,
    firstTwoWeeksMd,
  ),
  montarBonus(
    "plate-swap-chart",
    "The Plate Swap Chart",
    "One page for your refrigerator door",
    ArrowLeftRight,
    plateSwapChartMd,
  ),
  montarBonus(
    "sunday-in-two-hours",
    "Sunday in Two Hours",
    "Two hours on a Sunday and five weeknight dinners are in the freezer",
    Snowflake,
    sundayInTwoHoursMd,
  ),
];

export const bonusesRoute = `${CLEAN_MEALS_PREFIX}/bonuses`;
export const bonusRoute = (slug: string) => `${bonusesRoute}/${slug}`;
export const findBonus = (slug?: string) =>
  CLEAN_MEALS_BONUSES.find((b) => b.slug === slug) ?? null;
